import React from 'react';

import {Helmet, useParams} from 'views/module';

import CaseScene from 'views/scenes/case/CaseScene';

const CasePage = (props) => {
  const params = useParams();
  const caseRn = params.caseRn || undefined;

  return (
    <>
      <Helmet>
        <title>Quilt: Cases</title>
      </Helmet>
      <CaseScene selectedCaseRn={caseRn} />
    </>
  );
};

export default CasePage;
